module.exports = __webpack_public_path__ + "img/illustration-ready-0031ed01b67a52ac85edfefe1f37caaf.svg";